export const options = [
  {
    label: <span>Core Accounting</span>,
    title: "core-accounting",
    options: [
      { value: "account", label: "Account" },
      { value: "bill", label: "Bill" },
      { value: "budget", label: "Budget" },
      { value: "creditmemo", label: "Credit Memo" },
      { value: "deposit", label: "Deposit" },
      { value: "estimate", label: "Estimate" },
      { value: "invoice", label: "Invoice" },
      { value: "payment", label: "Payment" },
      { value: "purchaseorder", label: "Purchase Order" },
      { value: "refundreceipt", label: "Refund Receipt" },
      { value: "salesreceipt", label: "Sales Receipt" },
    ],
  },
  {
    label: <span>Entities</span>,
    title: "entities",
    options: [
      { value: "customer", label: "Customer" },
      { value: "employee", label: "Employee" },
      { value: "vendor", label: "Vendor" },
    ],
  },
  {
    label: <span>Item & Classification </span>,
    title: "item-classification",
    options: [
      { value: "item", label: "Item" },
      { value: "term", label: "Term" },
    ],
  },
  {
    label: <span>Taxes </span>,
    title: "taxes",
    options: [
      { value: "taxagency", label: "Tax Agency" },
      { value: "taxcode", label: "Tax Code" },
      { value: "taxrate", label: "Tax Rate" },
      // { value: "taxlinedetail", label: "Tax Line Detail" },
      // { value: "txntaxtdetail", label: "Txn Tax Detail" },
      // { value: "taxratedetail", label: "Tax Rate Details" },
      // { value: "taxratelist", label: "Tax Rate List" },
      // { value: "taxservice", label: "Tax Service" },
      { value: "companyinfo", label: "Company Info" },
      { value: "attachable", label: "Attachable" },
    ],
  },
];

export const accountColumns = [
  { title: "Name", dataIndex: "Name", key: "Name" },
  {
    title: "Account Sub Type",
    dataIndex: "AccountSubType",
    key: "AccountSubType",
  },
  { title: "Account Type", dataIndex: "AccountType", key: "AccountType" },
  { title: "Account Number", dataIndex: "AcctNum", key: "AcctNum" },
  { title: "Active", dataIndex: "Active", key: "Active" },
  {
    title: "Classification",
    dataIndex: "Classification",
    key: "Classification",
  },
  { title: "Currency", dataIndex: "CurrencyRef", key: "CurrencyRef" },
  {
    title: "Current Balance",
    dataIndex: "CurrentBalance",
    key: "CurrentBalance",
  },
  {
    title: "Balance With Sub Accounts",
    dataIndex: "CurrentBalanceWithSubAccounts",
    key: "CurrentBalanceWithSubAccounts",
  },
  { title: "Description", dataIndex: "Description", key: "Description" },
  {
    title: "Fully Qualified Name",
    dataIndex: "FullyQualifiedName",
    key: "FullyQualifiedName",
  },
  { title: "Parent Ref", dataIndex: "ParentRef", key: "ParentRef" },
  { title: "Sub Account", dataIndex: "SubAccount", key: "SubAccount" },
  { title: "Sync Token", dataIndex: "SyncToken", key: "SyncToken" },
  { title: "Tax Code Ref", dataIndex: "TaxCodeRef", key: "TaxCodeRef" },
  { title: "Domain", dataIndex: "domain", key: "domain" },
  {
    title: "QBO JSON Object Name",
    dataIndex: "qbo_json_object_name",
    key: "qbo_json_object_name",
  },
  {
    title: "QBO Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
  { title: "Sparse", dataIndex: "sparse", key: "sparse" },
];

export const invoiceColumns = [
  { title: "Customer", dataIndex: "CustomerRef", key: "CustomerRef" },
  { title: "Balance", dataIndex: "Balance", key: "Balance" },
  { title: "Bill Address", dataIndex: "BillAddr", key: "BillAddr" },
  { title: "Bill Email", dataIndex: "BillEmail", key: "BillEmail" },
  { title: "Currency", dataIndex: "CurrencyRef", key: "CurrencyRef" },
  { title: "Delivery Info", dataIndex: "DeliveryInfo", key: "DeliveryInfo" },
  { title: "Department", dataIndex: "DepartmentRef", key: "DepartmentRef" },
  { title: "Deposit", dataIndex: "Deposit", key: "Deposit" },
  { title: "Document Number", dataIndex: "DocNumber", key: "DocNumber" },
  { title: "Due Date", dataIndex: "DueDate", key: "DueDate" },
  {
    title: "E-Invoice Status",
    dataIndex: "EInvoiceStatus",
    key: "EInvoiceStatus",
  },
  { title: "Email Status", dataIndex: "EmailStatus", key: "EmailStatus" },
  { title: "Exchange Rate", dataIndex: "ExchangeRate", key: "ExchangeRate" },
  {
    title: "Free Form Address",
    dataIndex: "FreeFormAddress",
    key: "FreeFormAddress",
  },
  {
    title: "Global Tax Calculation",
    dataIndex: "GlobalTaxCalculation",
    key: "GlobalTaxCalculation",
  },
  { title: "Home Balance", dataIndex: "HomeBalance", key: "HomeBalance" },
  {
    title: "Home Total Amount",
    dataIndex: "HomeTotalAmt",
    key: "HomeTotalAmt",
  },
  { title: "Invoice Link", dataIndex: "InvoiceLink", key: "InvoiceLink" },
  { title: "Print Status", dataIndex: "PrintStatus", key: "PrintStatus" },
  { title: "Private Note", dataIndex: "PrivateNote", key: "PrivateNote" },
  {
    title: "Recurring Data Ref",
    dataIndex: "RecurDataRef",
    key: "RecurDataRef",
  },
  { title: "Sales Term", dataIndex: "SalesTermRef", key: "SalesTermRef" },
  { title: "Shipping Address", dataIndex: "ShipAddr", key: "ShipAddr" },
  { title: "Shipping Date", dataIndex: "ShipDate", key: "ShipDate" },
  {
    title: "Shipping Method",
    dataIndex: "ShipMethodRef",
    key: "ShipMethodRef",
  },
  { title: "Sync Token", dataIndex: "SyncToken", key: "SyncToken" },
  {
    title: "Tax Exemption",
    dataIndex: "TaxExemptionRef",
    key: "TaxExemptionRef",
  },
  { title: "Total Amount", dataIndex: "TotalAmt", key: "TotalAmt" },
  { title: "Tracking Number", dataIndex: "TrackingNum", key: "TrackingNum" },
  { title: "Transaction Date", dataIndex: "TxnDate", key: "TxnDate" },
  {
    title: "Transaction Tax Detail",
    dataIndex: "TxnTaxDetail",
    key: "TxnTaxDetail",
  },
  { title: "Domain", dataIndex: "domain", key: "domain" },
  { title: "Email Sent", dataIndex: "email_sent", key: "email_sent" },
  {
    title: "QBO JSON Object Name",
    dataIndex: "qbo_json_object_name",
    key: "qbo_json_object_name",
  },
  {
    title: "QBO Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
];

export const billPaymentColumns = [
  { title: "Domain", dataIndex: "domain", key: "domain" },
  {
    title: "Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
  { title: "Account Ref", dataIndex: "APAccountRef", key: "APAccountRef" },
  { title: "Total Amt", dataIndex: "TotalAmt", key: "TotalAmt" },
  { title: "Balance", dataIndex: "Balance", key: "Balance" },
  { title: "Currency", dataIndex: "CurrencyRef", key: "CurrencyRef" },
  { title: "Due Date", dataIndex: "DueDate", key: "DueDate" },
  { title: "Exchange Rate", dataIndex: "ExchangeRate", key: "ExchangeRate" },
  {
    title: "Tax Calc",
    dataIndex: "GlobalTaxCalculation",
    key: "GlobalTaxCalculation",
  },
  { title: "Vendor Address", dataIndex: "VendorAddr", key: "VendorAddr" },
  { title: "Vendor Ref", dataIndex: "VendorRef", key: "VendorRef" },
];

export const creditedColumns = [
  { title: "Domain", dataIndex: "domain", key: "domain" },
  {
    title: "Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
  { title: "Document Number", dataIndex: "DocNumber", key: "DocNumber" },
  { title: "Total Amt", dataIndex: "TotalAmt", key: "TotalAmt" },
  { title: "Txn Date", dataIndex: "TxnDate", key: "TxnDate" },
  {
    title: "Global Tax Calculation",
    dataIndex: "GlobalTaxCalculation",
    key: "GlobalTaxCalculation",
  },
  { title: "Balance", dataIndex: "Balance", key: "Balance" },
  {
    title: "Remaining Credit",
    dataIndex: "RemainingCredit",
    key: "RemainingCredit",
  },
  { title: "Currency", dataIndex: "CurrencyRef", key: "CurrencyRef" },
  { title: "Bill Address", dataIndex: "BillAddr", key: "BillAddr" },
  { title: "Bill Email", dataIndex: "BillEmail", key: "BillEmail" },
  { title: "Email Status", dataIndex: "EmailStatus", key: "EmailStatus" },
  { title: "Ship Address", dataIndex: "ShipAddr", key: "ShipAddr" },
  { title: "Customer Ref", dataIndex: "CustomerRef", key: "CustomerRef" },
  { title: "Customer Memo", dataIndex: "CustomerMemo", key: "CustomerMemo" },
  { title: "Print Status", dataIndex: "PrintStatus", key: "PrintStatus" },
];

export const depositColumns = [
  {
    title: "Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
  {
    title: "Attachable Ref",
    dataIndex: "AttachableRef",
    key: "AttachableRef",
  },
  {
    title: "Currency Ref",
    dataIndex: "CurrencyRef",
    key: "CurrencyRef",
  },
  {
    title: "Department Ref",
    dataIndex: "DepartmentRef",
    key: "DepartmentRef",
  },
  {
    title: "Deposit To Account Ref",
    dataIndex: "DepositToAccountRef",
    key: "DepositToAccountRef",
  },
  {
    title: "Doc Number",
    dataIndex: "DocNumber",
    key: "DocNumber",
  },
  {
    title: "Exchange Rate",
    dataIndex: "ExchangeRate",
    key: "ExchangeRate",
  },
  {
    title: "Global Tax Calculation",
    dataIndex: "GlobalTaxCalculation",
    key: "GlobalTaxCalculation",
  },
  {
    title: "Home Total Amount",
    dataIndex: "HomeTotalAmt",
    key: "HomeTotalAmt",
  },
  {
    title: "Private Note",
    dataIndex: "PrivateNote",
    key: "PrivateNote",
  },
  {
    title: "Total Amount",
    dataIndex: "TotalAmt",
    key: "TotalAmt",
  },
  {
    title: "Transaction Date",
    dataIndex: "TxnDate",
    key: "TxnDate",
  },
  {
    title: "Transaction Source",
    dataIndex: "TxnSource",
    key: "TxnSource",
  },
  {
    title: "Transaction Status",
    dataIndex: "TxnStatus",
    key: "TxnStatus",
  },
  {
    title: "Domain",
    dataIndex: "domain",
    key: "domain",
  },
];

export const estimateColumns = [
  {
    title: "Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
  {
    title: "Accepted By",
    dataIndex: "AcceptedBy",
    key: "AcceptedBy",
  },
  {
    title: "Accepted Date",
    dataIndex: "AcceptedDate",
    key: "AcceptedDate",
  },
  {
    title: "Apply Tax After Discount",
    dataIndex: "ApplyTaxAfterDiscount",
    key: "ApplyTaxAfterDiscount",
  },
  {
    title: "Bill Address",
    dataIndex: "BillAddr",
    key: "BillAddr",
  },
  {
    title: "Bill Email",
    dataIndex: "BillEmail",
    key: "BillEmail",
  },
  {
    title: "Class Ref",
    dataIndex: "ClassRef",
    key: "ClassRef",
  },
  {
    title: "Currency Ref",
    dataIndex: "CurrencyRef",
    key: "CurrencyRef",
  },
  {
    title: "Customer Memo",
    dataIndex: "CustomerMemo",
    key: "CustomerMemo",
  },
  {
    title: "Customer Ref",
    dataIndex: "CustomerRef",
    key: "CustomerRef",
  },
  {
    title: "Department Ref",
    dataIndex: "DepartmentRef",
    key: "DepartmentRef",
  },
  {
    title: "Document Number",
    dataIndex: "DocNumber",
    key: "DocNumber",
  },
  {
    title: "Due Date",
    dataIndex: "DueDate",
    key: "DueDate",
  },
  {
    title: "Email Status",
    dataIndex: "EmailStatus",
    key: "EmailStatus",
  },
  {
    title: "Exchange Rate",
    dataIndex: "ExchangeRate",
    key: "ExchangeRate",
  },
  {
    title: "Expiration Date",
    dataIndex: "ExpirationDate",
    key: "ExpirationDate",
  },
  {
    title: "Free Form Address",
    dataIndex: "FreeFormAddress",
    key: "FreeFormAddress",
  },
  {
    title: "Global Tax Calculation",
    dataIndex: "GlobalTaxCalculation",
    key: "GlobalTaxCalculation",
  },
  {
    title: "Print Status",
    dataIndex: "PrintStatus",
    key: "PrintStatus",
  },
  {
    title: "Private Note",
    dataIndex: "PrivateNote",
    key: "PrivateNote",
  },
  {
    title: "Project Ref",
    dataIndex: "ProjectRef",
    key: "ProjectRef",
  },
  {
    title: "Sales Term Ref",
    dataIndex: "SalesTermRef",
    key: "SalesTermRef",
  },
  {
    title: "Ship Address",
    dataIndex: "ShipAddr",
    key: "ShipAddr",
  },
  {
    title: "Ship Date",
    dataIndex: "ShipDate",
    key: "ShipDate",
  },
  {
    title: "Ship From Address",
    dataIndex: "ShipFromAddr",
    key: "ShipFromAddr",
  },
  {
    title: "Ship Method Ref",
    dataIndex: "ShipMethodRef",
    key: "ShipMethodRef",
  },
  {
    title: "Sync Token",
    dataIndex: "SyncToken",
    key: "SyncToken",
  },
  {
    title: "Total Amount",
    dataIndex: "TotalAmt",
    key: "TotalAmt",
  },
  {
    title: "Tracking Number",
    dataIndex: "TrackingNum",
    key: "TrackingNum",
  },
  {
    title: "Transaction Date",
    dataIndex: "TxnDate",
    key: "TxnDate",
  },
  {
    title: "Transaction Status",
    dataIndex: "TxnStatus",
    key: "TxnStatus",
  },
  {
    title: "Transaction Tax Detail",
    dataIndex: "TxnTaxDetail",
    key: "TxnTaxDetail",
  },
  {
    title: "Domain",
    dataIndex: "domain",
    key: "domain",
  },
];

export const paymentColumns = [
  {
    title: "Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
  {
    title: "Domain",
    dataIndex: "domain",
    key: "domain",
  },
  {
    title: "AR Account Ref",
    dataIndex: "ARAccountRef",
    key: "ARAccountRef",
  },
  {
    title: "Credit Card Payment",
    dataIndex: "CreditCardPayment",
    key: "CreditCardPayment",
  },
  {
    title: "Currency Ref",
    dataIndex: "CurrencyRef",
    key: "CurrencyRef",
  },
  {
    title: "Customer Ref",
    dataIndex: "CustomerRef",
    key: "CustomerRef",
  },
  {
    title: "Deposit To Account Ref",
    dataIndex: "DepositToAccountRef",
    key: "DepositToAccountRef",
  },
  {
    title: "Exchange Rate",
    dataIndex: "ExchangeRate",
    key: "ExchangeRate",
  },
  {
    title: "Payment Method Ref",
    dataIndex: "PaymentMethodRef",
    key: "PaymentMethodRef",
  },
  {
    title: "Payment Reference Number",
    dataIndex: "PaymentRefNum",
    key: "PaymentRefNum",
  },
  {
    title: "Private Note",
    dataIndex: "PrivateNote",
    key: "PrivateNote",
  },
  {
    title: "Process Payment",
    dataIndex: "ProcessPayment",
    key: "ProcessPayment",
  },
  {
    title: "Tax Exemption Ref",
    dataIndex: "TaxExemptionRef",
    key: "TaxExemptionRef",
  },
  {
    title: "Total Amount",
    dataIndex: "TotalAmt",
    key: "TotalAmt",
  },
  {
    title: "Transaction Location Type",
    dataIndex: "TransactionLocationType",
    key: "TransactionLocationType",
  },
  {
    title: "Transaction Date",
    dataIndex: "TxnDate",
    key: "TxnDate",
  },
  {
    title: "Transaction Source",
    dataIndex: "TxnSource",
    key: "TxnSource",
  },
  {
    title: "Transaction Status",
    dataIndex: "TxnStatus",
    key: "TxnStatus",
  },
  {
    title: "Unapplied Amount",
    dataIndex: "UnappliedAmt",
    key: "UnappliedAmt",
  },
];

export const purchaseOrderColumns = [
  {
    title: "AP Account Ref",
    dataIndex: "APAccountRef",
    key: "APAccountRef",
  },
  {
    title: "Attachable Ref",
    dataIndex: "AttachableRef",
    key: "AttachableRef",
  },
  {
    title: "Class Ref",
    dataIndex: "ClassRef",
    key: "ClassRef",
  },
  {
    title: "Currency Ref",
    dataIndex: "CurrencyRef",
    key: "CurrencyRef",
  },
  {
    title: "Document Number",
    dataIndex: "DocNumber",
    key: "DocNumber",
  },
  {
    title: "Due Date",
    dataIndex: "DueDate",
    key: "DueDate",
  },
  {
    title: "Email Status",
    dataIndex: "EmailStatus",
    key: "EmailStatus",
  },
  {
    title: "Exchange Rate",
    dataIndex: "ExchangeRate",
    key: "ExchangeRate",
  },
  {
    title: "Global Tax Calculation",
    dataIndex: "GlobalTaxCalculation",
    key: "GlobalTaxCalculation",
  },
  {
    title: "Purchase Order Status",
    dataIndex: "POStatus",
    key: "POStatus",
  },
  {
    title: "Private Note",
    dataIndex: "PrivateNote",
    key: "PrivateNote",
  },
  {
    title: "Sales Term Ref",
    dataIndex: "SalesTermRef",
    key: "SalesTermRef",
  },
  {
    title: "Ship Address",
    dataIndex: "ShipAddr",
    key: "ShipAddr",
  },
  {
    title: "Ship Method Ref",
    dataIndex: "ShipMethodRef",
    key: "ShipMethodRef",
  },
  {
    title: "Tax Code Ref",
    dataIndex: "TaxCodeRef",
    key: "TaxCodeRef",
  },
  {
    title: "Total Amount",
    dataIndex: "TotalAmt",
    key: "TotalAmt",
  },
  {
    title: "Transaction Date",
    dataIndex: "TxnDate",
    key: "TxnDate",
  },
  {
    title: "Transaction Tax Detail",
    dataIndex: "TxnTaxDetail",
    key: "TxnTaxDetail",
  },
  {
    title: "Vendor Address",
    dataIndex: "VendorAddr",
    key: "VendorAddr",
  },
  {
    title: "Vendor Ref",
    dataIndex: "VendorRef",
    key: "VendorRef",
  },
  {
    title: "Domain",
    dataIndex: "domain",
    key: "domain",
  },
  {
    title: "QBO Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
];

export const refundReceiptColumns = [
  {
    title: "Apply Tax After Discount",
    dataIndex: "ApplyTaxAfterDiscount",
    key: "ApplyTaxAfterDiscount",
  },
  {
    title: "Balance",
    dataIndex: "Balance",
    key: "Balance",
  },
  {
    title: "Bill Address",
    dataIndex: "BillAddr",
    key: "BillAddr",
  },
  {
    title: "Bill Email",
    dataIndex: "BillEmail",
    key: "BillEmail",
  },
  {
    title: "Check Payment",
    dataIndex: "CheckPayment",
    key: "CheckPayment",
  },
  {
    title: "Class Ref",
    dataIndex: "ClassRef",
    key: "ClassRef",
  },
  {
    title: "Credit Card Payment",
    dataIndex: "CreditCardPayment",
    key: "CreditCardPayment",
  },
  {
    title: "Currency Ref",
    dataIndex: "CurrencyRef",
    key: "CurrencyRef",
  },
  {
    title: "Customer Memo",
    dataIndex: "CustomerMemo",
    key: "CustomerMemo",
  },
  {
    title: "Customer Ref",
    dataIndex: "CustomerRef",
    key: "CustomerRef",
  },
  {
    title: "Department Ref",
    dataIndex: "DepartmentRef",
    key: "DepartmentRef",
  },
  {
    title: "Deposit To Account Ref",
    dataIndex: "DepositToAccountRef",
    key: "DepositToAccountRef",
  },
  {
    title: "Document Number",
    dataIndex: "DocNumber",
    key: "DocNumber",
  },
  {
    title: "Exchange Rate",
    dataIndex: "ExchangeRate",
    key: "ExchangeRate",
  },
  {
    title: "Free Form Address",
    dataIndex: "FreeFormAddress",
    key: "FreeFormAddress",
  },
  {
    title: "Global Tax Calculation",
    dataIndex: "GlobalTaxCalculation",
    key: "GlobalTaxCalculation",
  },
  {
    title: "Memo",
    dataIndex: "Memo",
    key: "Memo",
  },
  {
    title: "Payment Method Ref",
    dataIndex: "PaymentMethodRef",
    key: "PaymentMethodRef",
  },
  {
    title: "Payment Reference Number",
    dataIndex: "PaymentRefNum",
    key: "PaymentRefNum",
  },
  {
    title: "Payment Type",
    dataIndex: "PaymentType",
    key: "PaymentType",
  },
  {
    title: "Print Status",
    dataIndex: "PrintStatus",
    key: "PrintStatus",
  },
  {
    title: "Private Note",
    dataIndex: "PrivateNote",
    key: "PrivateNote",
  },
  {
    title: "Ship Address",
    dataIndex: "ShipAddr",
    key: "ShipAddr",
  },
  {
    title: "Total Amount",
    dataIndex: "TotalAmt",
    key: "TotalAmt",
  },
  {
    title: "Transaction Date",
    dataIndex: "TxnDate",
    key: "TxnDate",
  },
  {
    title: "Transaction Source",
    dataIndex: "TxnSource",
    key: "TxnSource",
  },
  {
    title: "QBO Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
];

export const customerColumns = [
  {
    title: "AR Account Ref",
    dataIndex: "ARAccountRef",
    key: "ARAccountRef",
  },
  {
    title: "Active",
    dataIndex: "Active",
    key: "Active",
  },
  {
    title: "Alternate Phone",
    dataIndex: "AlternatePhone",
    key: "AlternatePhone",
  },
  {
    title: "Balance",
    dataIndex: "Balance",
    key: "Balance",
  },
  {
    title: "Balance With Jobs",
    dataIndex: "BalanceWithJobs",
    key: "BalanceWithJobs",
  },
  {
    title: "Bill Address",
    dataIndex: "BillAddr",
    key: "BillAddr",
  },
  {
    title: "Bill With Parent",
    dataIndex: "BillWithParent",
    key: "BillWithParent",
  },
  {
    title: "Client Entity ID",
    dataIndex: "ClientEntityId",
    key: "ClientEntityId",
  },
  {
    title: "Company Name",
    dataIndex: "CompanyName",
    key: "CompanyName",
  },
  {
    title: "Currency Ref",
    dataIndex: "CurrencyRef",
    key: "CurrencyRef",
  },
  {
    title: "Default Tax Code Ref",
    dataIndex: "DefaultTaxCodeRef",
    key: "DefaultTaxCodeRef",
  },
  {
    title: "Display Name",
    dataIndex: "DisplayName",
    key: "DisplayName",
  },
  {
    title: "Family Name",
    dataIndex: "FamilyName",
    key: "FamilyName",
  },
  {
    title: "Fax",
    dataIndex: "Fax",
    key: "Fax",
  },
  {
    title: "Fully Qualified Name",
    dataIndex: "FullyQualifiedName",
    key: "FullyQualifiedName",
  },
  {
    title: "Given Name",
    dataIndex: "GivenName",
    key: "GivenName",
  },
  {
    title: "Middle Name",
    dataIndex: "MiddleName",
    key: "MiddleName",
  },
  {
    title: "Mobile",
    dataIndex: "Mobile",
    key: "Mobile",
  },
  {
    title: "Notes",
    dataIndex: "Notes",
    key: "Notes",
  },
  {
    title: "Open Balance Date",
    dataIndex: "OpenBalanceDate",
    key: "OpenBalanceDate",
  },
  {
    title: "Parent Ref",
    dataIndex: "ParentRef",
    key: "ParentRef",
  },
  {
    title: "Payment Method Ref",
    dataIndex: "PaymentMethodRef",
    key: "PaymentMethodRef",
  },
  {
    title: "Preferred Delivery Method",
    dataIndex: "PreferredDeliveryMethod",
    key: "PreferredDeliveryMethod",
  },
  {
    title: "Primary Email Address",
    dataIndex: "PrimaryEmailAddr",
    key: "PrimaryEmailAddr",
  },
  {
    title: "Primary Phone",
    dataIndex: "PrimaryPhone",
    key: "PrimaryPhone",
  },
  {
    title: "Primary Tax Identifier",
    dataIndex: "PrimaryTaxIdentifier",
    key: "PrimaryTaxIdentifier",
  },
  {
    title: "Print On Check Name",
    dataIndex: "PrintOnCheckName",
    key: "PrintOnCheckName",
  },
  {
    title: "Resale Number",
    dataIndex: "ResaleNum",
    key: "ResaleNum",
  },
  {
    title: "Sales Term Ref",
    dataIndex: "SalesTermRef",
    key: "SalesTermRef",
  },
  {
    title: "Ship Address",
    dataIndex: "ShipAddr",
    key: "ShipAddr",
  },
  {
    title: "Taxable",
    dataIndex: "Taxable",
    key: "Taxable",
  },
  {
    title: "QBO Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
];

export const employeeColumns = [
  {
    title: "Active",
    dataIndex: "Active",
    key: "Active",
  },
  {
    title: "Bill Rate",
    dataIndex: "BillRate",
    key: "BillRate",
  },
  {
    title: "Billable Time",
    dataIndex: "BillableTime",
    key: "BillableTime",
  },
  {
    title: "Birth Date",
    dataIndex: "BirthDate",
    key: "BirthDate",
  },
  {
    title: "Cost Rate",
    dataIndex: "CostRate",
    key: "CostRate",
  },
  {
    title: "Display Name",
    dataIndex: "DisplayName",
    key: "DisplayName",
  },
  {
    title: "Email Address",
    dataIndex: "EmailAddress",
    key: "EmailAddress",
  },
  {
    title: "Employee Number",
    dataIndex: "EmployeeNumber",
    key: "EmployeeNumber",
  },
  {
    title: "Family Name",
    dataIndex: "FamilyName",
    key: "FamilyName",
  },
  {
    title: "Gender",
    dataIndex: "Gender",
    key: "Gender",
  },
  {
    title: "Given Name",
    dataIndex: "GivenName",
    key: "GivenName",
  },
  {
    title: "Hired Date",
    dataIndex: "HiredDate",
    key: "HiredDate",
  },
  {
    title: "Middle Name",
    dataIndex: "MiddleName",
    key: "MiddleName",
  },
  {
    title: "Mobile",
    dataIndex: "Mobile",
    key: "Mobile",
  },
  {
    title: "Organization",
    dataIndex: "Organization",
    key: "Organization",
  },
  {
    title: "Primary Address",
    dataIndex: "PrimaryAddr",
    key: "PrimaryAddr",
  },
  {
    title: "Primary Phone",
    dataIndex: "PrimaryPhone",
    key: "PrimaryPhone",
  },
  {
    title: "Print On Check Name",
    dataIndex: "PrintOnCheckName",
    key: "PrintOnCheckName",
  },
  {
    title: "Released Date",
    dataIndex: "ReleasedDate",
    key: "ReleasedDate",
  },
  {
    title: "QBO Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
];

export const vendorColumns = [
  {
    title: "AP Account Ref",
    dataIndex: "APAccountRef",
    key: "APAccountRef",
  },
  {
    title: "Account Number",
    dataIndex: "AcctNum",
    key: "AcctNum",
  },
  {
    title: "Active",
    dataIndex: "Active",
    key: "Active",
  },
  {
    title: "Alternate Phone",
    dataIndex: "AlternatePhone",
    key: "AlternatePhone",
  },
  {
    title: "Balance",
    dataIndex: "Balance",
    key: "Balance",
  },
  {
    title: "Bill Address",
    dataIndex: "BillAddr",
    key: "BillAddr",
  },
  {
    title: "Bill Rate",
    dataIndex: "BillRate",
    key: "BillRate",
  },
  {
    title: "Company Name",
    dataIndex: "CompanyName",
    key: "CompanyName",
  },
  {
    title: "Currency Ref",
    dataIndex: "CurrencyRef",
    key: "CurrencyRef",
  },
  {
    title: "Display Name",
    dataIndex: "DisplayName",
    key: "DisplayName",
  },
  {
    title: "Family Name",
    dataIndex: "FamilyName",
    key: "FamilyName",
  },
  {
    title: "Fax",
    dataIndex: "Fax",
    key: "Fax",
  },
  {
    title: "Given Name",
    dataIndex: "GivenName",
    key: "GivenName",
  },
  {
    title: "Middle Name",
    dataIndex: "MiddleName",
    key: "MiddleName",
  },
  {
    title: "Mobile",
    dataIndex: "Mobile",
    key: "Mobile",
  },
  {
    title: "Primary Email Address",
    dataIndex: "PrimaryEmailAddr",
    key: "PrimaryEmailAddr",
  },
  {
    title: "Primary Phone",
    dataIndex: "PrimaryPhone",
    key: "PrimaryPhone",
  },
  {
    title: "Print On Check Name",
    dataIndex: "PrintOnCheckName",
    key: "PrintOnCheckName",
  },
  {
    title: "Suffix",
    dataIndex: "Suffix",
    key: "Suffix",
  },
  {
    title: "Sync Token",
    dataIndex: "SyncToken",
    key: "SyncToken",
  },
  {
    title: "Tax Identifier",
    dataIndex: "TaxIdentifier",
    key: "TaxIdentifier",
  },
  {
    title: "Tax Reporting Basis",
    dataIndex: "TaxReportingBasis",
    key: "TaxReportingBasis",
  },
  {
    title: "Term Ref",
    dataIndex: "TermRef",
    key: "TermRef",
  },
  {
    title: "QBO Object Name",
    dataIndex: "qbo_object_name",
    key: "qbo_object_name",
  },
];

export const itemColumns = [
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Description",
    dataIndex: "Description",
    key: "Description",
  },
  {
    title: "Abatement Rate",
    dataIndex: "AbatementRate",
    key: "AbatementRate",
  },
  {
    title: "Active",
    dataIndex: "Active",
    key: "Active",
  },
  {
    title: "Asset Account Ref",
    dataIndex: "AssetAccountRef",
    key: "AssetAccountRef",
  },
  {
    title: "Expense Account Ref",
    dataIndex: "ExpenseAccountRef",
    key: "ExpenseAccountRef",
  },
  {
    title: "Fully Qualified Name",
    dataIndex: "FullyQualifiedName",
    key: "FullyQualifiedName",
  },
  {
    title: "Income Account Ref",
    dataIndex: "IncomeAccountRef",
    key: "IncomeAccountRef",
  },
  {
    title: "Inv Start Date",
    dataIndex: "InvStartDate",
    key: "InvStartDate",
  },
  {
    title: "Item Category Type",
    dataIndex: "ItemCategoryType",
    key: "ItemCategoryType",
  },
  {
    title: "Level",
    dataIndex: "Level",
    key: "Level",
  },
  {
    title: "Parent Ref",
    dataIndex: "ParentRef",
    key: "ParentRef",
  },
  {
    title: "Purchase Cost",
    dataIndex: "PurchaseCost",
    key: "PurchaseCost",
  },
  {
    title: "Purchase Desc",
    dataIndex: "PurchaseDesc",
    key: "PurchaseDesc",
  },
  {
    title: "Purchase Tax Code Ref",
    dataIndex: "PurchaseTaxCodeRef",
    key: "PurchaseTaxCodeRef",
  },
  {
    title: "Purchase Tax Included",
    dataIndex: "PurchaseTaxIncluded",
    key: "PurchaseTaxIncluded",
  },
  {
    title: "Qty On Hand",
    dataIndex: "QtyOnHand",
    key: "QtyOnHand",
  },
  {
    title: "Reverse Charge Rate",
    dataIndex: "ReverseChargeRate",
    key: "ReverseChargeRate",
  },
  {
    title: "Sales Tax Code Ref",
    dataIndex: "SalesTaxCodeRef",
    key: "SalesTaxCodeRef",
  },
  {
    title: "Sales Tax Included",
    dataIndex: "SalesTaxIncluded",
    key: "SalesTaxIncluded",
  },
  {
    title: "Service Type",
    dataIndex: "ServiceType",
    key: "ServiceType",
  },
  {
    title: "Sku",
    dataIndex: "Sku",
    key: "Sku",
  },
  {
    title: "Sub Item",
    dataIndex: "SubItem",
    key: "SubItem",
  },
  {
    title: "Taxable",
    dataIndex: "Taxable",
    key: "Taxable",
  },
  {
    title: "Track Qty On Hand",
    dataIndex: "TrackQtyOnHand",
    key: "TrackQtyOnHand",
  },
  {
    title: "Type",
    dataIndex: "Type",
    key: "Type",
  },
  {
    title: "Unit Price",
    dataIndex: "UnitPrice",
    key: "UnitPrice",
  },
];

export const termColumns = [
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Type",
    dataIndex: "Type",
    key: "Type",
  },
  {
    title: "Active",
    dataIndex: "Active",
    key: "Active",
  },
  {
    title: "Day Of Month Due",
    dataIndex: "DayOfMonthDue",
    key: "DayOfMonthDue",
  },
  {
    title: "Discount Day Of Month",
    dataIndex: "DiscountDayOfMonth",
    key: "DiscountDayOfMonth",
  },
  {
    title: "Discount Days",
    dataIndex: "DiscountDays",
    key: "DiscountDays",
  },
  {
    title: "Discount Percent",
    dataIndex: "DiscountPercent",
    key: "DiscountPercent",
  },
  {
    title: "Due Days",
    dataIndex: "DueDays",
    key: "DueDays",
  },
  {
    title: "Due Next Month Days",
    dataIndex: "DueNextMonthDays",
    key: "DueNextMonthDays",
  },
];
export const taxAgencyColumns = [
  {
    title: "Display Name",
    dataIndex: "DisplayName",
    key: "DisplayName",
  },
  {
    title: "Tax Agency Config",
    dataIndex: "TaxAgencyConfig",
    key: "TaxAgencyConfig",
  },
  {
    title: "Tax Registration Number",
    dataIndex: "TaxRegistrationNumber",
    key: "TaxRegistrationNumber",
  },
  {
    title: "Tax Tracked On Purchases",
    dataIndex: "TaxTrackedOnPurchases",
    key: "TaxTrackedOnPurchases",
  },
  {
    title: "Tax Tracked On Sales",
    dataIndex: "TaxTrackedOnSales",
    key: "TaxTrackedOnSales",
  },
];

export const taxCodeColumns = [
  {
    title: "Id",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Active",
    dataIndex: "Active",
    key: "Active",
  },
  {
    title: "Description",
    dataIndex: "Description",
    key: "Description",
  },
  {
    title: "Purchase Tax Rate List",
    dataIndex: "PurchaseTaxRateList",
    key: "PurchaseTaxRateList",
  },
  {
    title: "Sales Tax Rate List",
    dataIndex: "SalesTaxRateList",
    key: "SalesTaxRateList",
  },
  {
    title: "Sync Token",
    dataIndex: "SyncToken",
    key: "SyncToken",
  },
  {
    title: "Tax Group",
    dataIndex: "TaxGroup",
    key: "TaxGroup",
  },
  {
    title: "Taxable",
    dataIndex: "Taxable",
    key: "Taxable",
  },
];
export const taxRateColumns = [
  {
    title: "Id",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Active",
    dataIndex: "Active",
    key: "Active",
  },
  {
    title: "Agency Ref",
    dataIndex: "AgencyRef",
    key: "AgencyRef",
  },
  {
    title: "Description",
    dataIndex: "Description",
    key: "Description",
  },
  {
    title: "Display Type",
    dataIndex: "DisplayType",
    key: "DisplayType",
  },
  {
    title: "Effective Tax Rate",
    dataIndex: "EffectiveTaxRate",
    key: "EffectiveTaxRate",
  },
  {
    title: "Rate Value",
    dataIndex: "RateValue",
    key: "RateValue",
  },
  {
    title: "Special Tax Type",
    dataIndex: "SpecialTaxType",
    key: "SpecialTaxType",
  },
  {
    title: "Sync Token",
    dataIndex: "SyncToken",
    key: "SyncToken",
  },
  {
    title: "Tax Return Line Ref",
    dataIndex: "TaxReturnLineRef",
    key: "TaxReturnLineRef",
  },
];

export const companyInfoColumns = [
  {
    title: "Company Address",
    dataIndex: "CompanyAddr",
    key: "CompanyAddr",
  },
  {
    title: "Company Name",
    dataIndex: "CompanyName",
    key: "CompanyName",
  },
  {
    title: "Company Start Date",
    dataIndex: "CompanyStartDate",
    key: "CompanyStartDate",
  },
  {
    title: "Country",
    dataIndex: "Country",
    key: "Country",
  },
  {
    title: "Customer Communication Address",
    dataIndex: "CustomerCommunicationAddr",
    key: "CustomerCommunicationAddr",
  },
  {
    title: "Customer Communication Email Address",
    dataIndex: "CustomerCommunicationEmailAddr",
    key: "CustomerCommunicationEmailAddr",
  },
  {
    title: "Default Time Zone",
    dataIndex: "DefaultTimeZone",
    key: "DefaultTimeZone",
  },
  {
    title: "Email",
    dataIndex: "Email",
    key: "Email",
  },
  {
    title: "Fiscal Year Start Month",
    dataIndex: "FiscalYearStartMonth",
    key: "FiscalYearStartMonth",
  },
  {
    title: "Id",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Legal Address",
    dataIndex: "LegalAddr",
    key: "LegalAddr",
  },
  {
    title: "Legal Name",
    dataIndex: "LegalName",
    key: "LegalName",
  },
  {
    title: "Name Value",
    dataIndex: "NameValue",
    key: "NameValue",
  },
  {
    title: "Primary Phone",
    dataIndex: "PrimaryPhone",
    key: "PrimaryPhone",
  },
  {
    title: "Supported Languages",
    dataIndex: "SupportedLanguages",
    key: "SupportedLanguages",
  },
  {
    title: "Sync Token",
    dataIndex: "SyncToken",
    key: "SyncToken",
  },
  {
    title: "Web Address",
    dataIndex: "WebAddr",
    key: "WebAddr",
  },
];
